import { motion } from 'framer-motion';
import { Building2, MapPin, Activity, TrendingUp } from 'lucide-react';

export default function Clinic() {
  const stats = [
    { label: 'Total Clinics', value: '45', icon: Building2, color: 'bg-primary-500/100' },
    { label: 'Active Clinics', value: '38', icon: Activity, color: 'bg-medical-600' },
    { label: 'Locations', value: '12', icon: MapPin, color: 'bg-medical-400' },
    { label: 'Growth', value: '+8%', icon: TrendingUp, color: 'bg-medical-700' },
  ];

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {stats.map((stat, index) => (
          <motion.div
            key={stat.label}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
            className="bg-white rounded-xl shadow-sm p-6"
          >
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-slate-600 mb-1">{stat.label}</p>
                <p className="text-2xl font-bold text-slate-900">{stat.value}</p>
              </div>
              <div className={`${stat.color} p-3 rounded-lg`}>
                <stat.icon className="w-6 h-6 text-slate-900" />
              </div>
            </div>
          </motion.div>
        ))}
      </div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.4 }}
        className="bg-white rounded-xl shadow-sm p-6"
      >
        <h3 className="text-lg font-bold text-slate-900 mb-4">Clinic Management</h3>
        <p className="text-slate-600">Clinic management features will be displayed here.</p>
      </motion.div>
    </div>
  );
}